@if(!!vehicle()?.tool) {
  <div class="flex flex-col">
    <div class="text-xs">
      {{ vehicle().tool.serialNumber }}
    </div>
    <div class="font-bold">
      {{ vehicle().name }}
    </div>
    <div class="font-light text-xs">
      {{ vehicle().type.tradeName }}
    </div>
    @if(vehicle()?.customerInformation?.customer; as customer) {
      <div class="text-xs font-semibold text-light">
        {{ customer?.number + ' - ' + customer?.name }}
      </div>
    }
  </div>
} @else {
  <div class="flex flex-col">
    <div class="text-xs">
      {{ vehicle().number }}
    </div>
    <div class="font-bold">
      {{ vehicle().name }}
    </div>
    <div class="font-light text-xs">
      {{ vehicle().general.licensePlateNumber }}
    </div>
  </div>
}
